import { Directive, HostListener } from '@angular/core';
import { QuoteSteps } from '../models/enums/quote-steps';
import { HouseholdQuoteStateService } from '../services/household-quote-state-service/household-quote-state.service';
import { FormNames } from '../models/enums/quote-form-names';

@Directive({ selector: '[appUnloadBrowserNotification]' })

export class UnloadBrowserNotificationDirective {

    constructor(private householdQuoteStateService: HouseholdQuoteStateService) {
    }

    @HostListener('window:beforeunload', ['$event']) beforeUnloadNotification($event: any) {
        this.showUnLoadMessage($event);
    }

    private showUnLoadMessage($event: any): string {
        const result = this.householdQuoteStateService.getFormState(FormNames.quoteForm)?.form?.dirty;
        const resultQQ = this.householdQuoteStateService.getFormState(FormNames.QuickOuestionsForm)?.form?.dirty;
        if (result || resultQQ) {
            if (this.householdQuoteStateService.getCurrentStep() !== QuoteSteps.none &&
            this.householdQuoteStateService.getCurrentStep() !== QuoteSteps.quickQuestionsSuccess &&
                this.householdQuoteStateService.getCurrentStep() !== QuoteSteps.confirmation) {
                var confirmationMessage = 'Changes you made may not be saved.';
                ($event || window.event).returnValue = confirmationMessage; //Gecko + IE
                ($event || window.event).cancelBubble = true;
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            }
        }
        return '';
    }
}